import { styled } from "@material-ui/styles";
import List from "@mui/material/List";

const CommonList = styled(List)(({ theme }) => ({
  "&.MuiList-root": {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    "&:first-child": { paddingTop: "8px" },
    "& .MuiListItem-root": {
      "& .MuiListItemButton-root": {
        padding: "8px 0",
        "& .MuiListItemIcon-root": {
          minWidth: "fit-content",
          "& .MuiBox-root": {
            margin: 0,
          },
        },
        "& .MuiListItemText-root": {
          maxWidth: "120px",
          "& .MuiTypography-root": {
            wordBreak: "break-word",
          },
        },
      },
      "& .MuiListItemSecondaryAction-root": {
        "& .MuiIconButton-root": { padding: 0 },
      },
    },
  },
}));

export default CommonList;
